// lbl.home
export const home = {
    title: "Hello World!",
    insuranceExpire: 'One of your insurance policy is about to expired',
    viewInsurance: 'View My Insurance',
    privildges_foryou: 'Privildges/Rewards for you',
    deals_foryou: 'Deals for you',
    no_data: 'No Data',

    input_field: 'Please input field',
    password_format: 'password/pin invalid format',
    password_not_match: 'password/pin not match',
    more_information: 'Contact for more information',
    title_logout: 'Confirm logout ? ',
    confirm_logout: 'Do you want to logout ?',
    login: {
        register_login: 'Register/Login',
        place_username: 'Contact number',
        mobile_incorrect: 'Please enter the current information',
        confirm: 'Confirm',
        or: 'or',
        login_line: 'Login via Line',
        login_facebook: 'Login via Facebook',
        cant_login: 'Please contact our staff if you are unable to login',
        enter_password: 'Please enter your Pasword',
        enter_pincode: 'Please enter your PIN Code',
        condition_password: 'Password must contain 8-20 characters including Captital letters, small letters, and numbers',
        condition_pincode: 'Password must contain numbers 0-9 8 characters',
        password_incorrect: 'Please enter the current information',
        login: 'Login',
        please_login: 'Please Login'
    },
    tab_menu: {
        main: 'Main',
        privilege: 'Privilege',
        history: 'History',
        profile: 'Profile',
        profile_edit: 'Profile edit',
        deals_for_you: 'Deals for you',
        mission: 'Mission'
    },
};
